// Claves de TanStack Query (ARCHITECTURE §9): `[módulo, locationId, …]`. Los eventos SSE invalidan por prefijo,
// así que cada feature tiene que empezar sus claves con el módulo y, si los datos son de un local, con su id.
//
// Prefijos por local: agenda, onlineBookings, queues, sales (caja), stock, giftcards, commissions, team, catalog,
// settings. Del negocio (sin local): clients, users, business, finance, dashboard, audit.

export const qk = {
  session: ['session'] as const,
  authConfig: ['auth', 'config'] as const,
  systemInfo: ['system', 'info'] as const,
  twoFactorStatus: ['auth', '2fa'] as const,
  sessions: ['auth', 'sessions'] as const,
  queues: (locationId: string) => ['queues', locationId] as const,
  onlineBookings: (locationId: string, view: 'bell' | 'unseen' | 'recent') => ['onlineBookings', locationId, view] as const,

  /** Prefijo de un módulo en un local (para invalidar). */
  module: (module: QueryModule, locationId?: string | null) => (locationId ? ([module, locationId] as const) : ([module] as const)),
};

export type QueryModule =
  | 'agenda'
  | 'onlineBookings'
  | 'queues'
  | 'sales'
  | 'stock'
  | 'giftcards'
  | 'commissions'
  | 'team'
  | 'catalog'
  | 'settings'
  | 'clients'
  | 'users'
  | 'business'
  | 'finance'
  | 'dashboard'
  | 'audit';
